module.exports = __webpack_public_path__ + "img/NBT.ad153ca2.svg";